// API 基础配置
const API_BASE_URL = 'https://dk-backend.ibase.site/api/v1';

// 通用的API响应类型
export interface ApiResponse<T = any> {
  status: number;
  data?: T;
  msg?: string;
  error?: string;
}

// 用户类型
export interface User {
  id: number;
  username: string;
  status: string;
  is_doctor: boolean;
}

// 登录/注册响应数据类型
export interface AuthData {
  user: User;
  token: string;
}

// 登录请求参数
export interface LoginParams {
  username: string;
  password: string;
}

// 注册请求参数
export interface RegisterParams {
  username: string;
  password: string;
  password2: string;
}

// 通用请求函数
const request = async <T = any>(
  url: string,
  options: RequestInit = {}
): Promise<ApiResponse<T>> => {
  const response = await fetch(`${API_BASE_URL}${url}`, {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });

  const data = await response.json();
  return data;
};

// API 方法
export const api = {
  // 登录
  login: (params: LoginParams): Promise<ApiResponse<AuthData>> =>
    request('/login', {
      method: 'POST',
      body: JSON.stringify(params),
    }),

  // 注册
  register: (params: RegisterParams): Promise<ApiResponse<AuthData>> =>
    request('/register', {
      method: 'POST',
      body: JSON.stringify(params),
    }),

  // Ping 测试
  ping: (): Promise<ApiResponse> =>
    request('/ping', {
      method: 'GET',
    }),

  // 需要认证的请求可以在这里添加
  // 例如：获取会话列表、添加会话等
};

export default api; 